// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1WdOp","inputWrap":"Table_inputWrap__2L6_o","col":"Table_col__1VbF2","bmiTooltip":"Table_bmiTooltip__2CMGI"};